import React, { useEffect, useState } from "react";
import { getDocs, collection, orderBy, limit, query } from "firebase/firestore";
import { db } from "../firebase-config";
import { useLocation, useNavigate } from "react-router-dom";
// import homeConan from "../assets/homeImages/homeConan.jpg"
import Biography from "../component/Biography";
import FeaturedUseCases from "../component/FeaturedUseCases";

function Home({ isAuth }) {
  const [featuredUseCases, setFeaturedUseCases] = useState([]);
  // console.log("Home component rendered");

  useEffect(() => {
    console.log("useEffect running: loading featured use cases");
    async function loadFeatured() {
      const useCasesRef = collection(db, "useCases");
      // Sort by title
      const q = query(useCasesRef, orderBy("Title"), limit(2));
      const snap = await getDocs(q);

      const results = snap.docs.map(doc => ({
        id: doc.id,
        ... doc.data()
      }));

      setFeaturedUseCases(results)
    }

    loadFeatured();
  }, []);

  return (
    <div className="homePage">
        <h1>
          Welcome!
        </h1>
      <div className="homePageContainer">
      {/* <div className="homeBiography">
        <div className="homeBiographyText">
          <p>
            <img src={homeConan} />
            Welcome! I’m Tyler, a certified Salesforce Administrator and Platform App Builder with over five years of experience optimizing CRM systems across industries. I specialize in streamlining workflows, building scalable automations, and enabling cross-functional teams to work smarter. From complex integrations to intuitive dashboards, my focus is on creating Salesforce solutions that drive efficiency, clarity, and measurable results.
          </p>
          <p>
            I love to read, to cook, and I love my dog, Conan. At school I studied French literature. As a teaching assistant at the University of Utah, I took classes like medieval French literature, Mondernist English literature, and classical Latin while teaching French 1010 and 1020. I had the chance to learn and develop my reading talent, a skill that I regularly use as I develop new solutions and keep myself up-to-date on industry standards.    
          </p>
          <p>
            I also practice my reading skills in the kitchen, finding new dishes to prepare for my family. Most recently I have been using my electric smoker to  prepare some of my favorites, like pork tenderloin or smoked chicken. My favorite part about cooking is reading recipes and using that skill to find new meals to share with my loved ones.   
          </p>
          <p>
            
          </p>
        </div>
      </div> */}
      {/* <div className="featuredUseCases">
        <h3>Use-cases</h3>
        {featuredUseCases.map(uc => (
          <div key={uc.id} className="featureCard">
            <h3>{uc.title}</h3>
            <p>{uc.description}</p>
            <a href={`/useCase/${uc.id}`} className="viewLink">View Details</a>
          </div>
        ))}
      </div> */}
      <Biography />
      <FeaturedUseCases />
    </div>
  </div>
        );
}

export default Home;